import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

import type { Country, InputProps } from './types';

interface Props extends InputProps {
  countries: Country[];
  onCountryIdChange?: (countryId: number) => void;
}

export default function CountryInput({ countries, options, value, onChange, onCountryIdChange }: Props) {
  if (countries.length === 1 || options.country?.show === false) {
    return null;
  }

  function handleValueChange(inputValue: string) {
    const countryId = Number(inputValue);
    onChange({ ...value, countryId });

    if (onCountryIdChange) {
      onCountryIdChange(countryId);
    }
  }

  return (
    <ManagedFormGroup
      disabled={options.country?.disabled}
      label={options.country?.label || 'Country'}
      required
      type="select"
      value={value.countryId}
      onValueChange={handleValueChange}
    >
      <Options
        labelName="name"
        options={countries}
        valueName="code"
      />
    </ManagedFormGroup>
  );
}
